/* unplugin-vue-components disabled */import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "editor-drawer__shapers flex flex-col"
};
const _hoisted_2 = {
  class: "grid grid-cols-3 gap-2 mt-6"
};
const _hoisted_3 = ["onClick", "innerHTML"];
import { useConfiguratorStore } from "@/stores/configurator";
import { useCreateEditorShape } from '@/composables/2dEditor/useCreateEditorShape';
import useGetShapeSvg from '@/composables/2dEditor/useGetShapeSvg';
import { createElementFromHTML } from '@/utils/common';
export default {
  __name: 'EditorDrawerShapes',
  setup(__props) {
    const configuratorStore = useConfiguratorStore();
    const $eventBus = inject('bus');
    const {
      closeDrawer
    } = configuratorStore;
    const shapes = [{
      icon: createElementFromHTML(useGetShapeSvg('triangle')),
      type: 'triangle'
    }, {
      icon: createElementFromHTML(useGetShapeSvg('circle')),
      type: 'circle'
    }, {
      icon: createElementFromHTML(useGetShapeSvg('hexagon')),
      type: 'hexagon'
    }, {
      icon: createElementFromHTML(useGetShapeSvg('rectangle')),
      type: 'rectangle'
    }, {
      icon: createElementFromHTML(useGetShapeSvg('line')),
      type: 'line'
    }, {
      icon: createElementFromHTML(useGetShapeSvg('trapezoid')),
      type: 'trapezoid'
    }];
    shapes.forEach(shape => {
      shape.icon.setAttribute('width', '100');
      shape.icon.setAttribute('height', '100');
      shape.icon.firstElementChild.setAttribute('fill', '#FF5722');
    });
    async function onClickHandleShapeClick(type) {
      const obj = await useCreateEditorShape(type);
      $eventBus.$emit("object-added-new", obj);
      closeDrawer();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(shapes, (shape, index) => {
        return _createElementVNode("div", {
          key: index
        }, [_createElementVNode("div", {
          class: "flex justify-center items-center h-[117px] hover:border-[0.2px] border-white cursor-pointer p-2",
          onClick: $event => onClickHandleShapeClick(shape.type),
          innerHTML: shape.icon.outerHTML
        }, null, 8, _hoisted_3)]);
      }), 64))])]);
    };
  }
};